import React from 'react';

import { useIntl } from 'react-intl-next';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { ToggleFilter } from '../../../../../common/ui/filters/toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import { useFiltersDiscoverability2Enabled, usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { filter as archivedFilter } from '../../../../../controllers/store/search/filters/archived';

import { i18n } from './messages';

const ArchivedFilter = ({
	isFilterInDropdown = false,
	showPrimaryProductIcon,
	onFilterChange,
}: FilterProps): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();
	const { formatMessage } = useIntl();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();
	const [state, { toggle }] = useBooleanFilter({
		filterId: archivedFilter.id,
	});

	if (!state) {
		return null;
	}

	const { value, autoFocus } = state;

	return (
		<ToggleFilter
			onChange={() => {
				toggle();
				onFilterChange?.({ isSelected: value });
			}}
			isChecked={value}
			autoFocus={autoFocus}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
			iconBefore={
				<FilterProductIcon
					primaryProduct={primaryProduct}
					showPrimaryProductIcon={showPrimaryProductIcon}
				/>
			}
		>
			{formatMessage(i18n.archived)}
		</ToggleFilter>
	);
};

export default ArchivedFilter;
